module.exports = function () {
    if ($('.careers-embedded-jobs').length) {
        var locationsActiveClass = 'careers-embedded-jobs__all-locations--visible';

        $('.careers-embedded-jobs__show-more').click(function (e) {
            e.preventDefault();

            var isHidden = $(this).data('locationsHidden');
            var $resultItem = $(this).closest('.careers-embedded-jobs-requisition');
            var $locations = $resultItem.find('.careers-embedded-jobs__all-locations');
            var showMoreText = isHidden ? 'Hide' : 'Show';

            if (isHidden) {
                $locations.addClass(locationsActiveClass);
                $locations.attr("aria-hidden", !isHidden);
            }
            else {
                $locations.removeClass(locationsActiveClass);
            }

            $(this).text(showMoreText);
            $(this).data('locationsHidden', !isHidden);
            $locations.attr("aria-hidden", !isHidden);
        });
    
    
        $('.careers-embedded-jobs-requisition-apply-link').click(function () {
            var requisitionId = $(this).data('requisitionId');

            ICF.Modules.Analytics.TrackGoal('Apply Button Click', requisitionId);
        });
    }
};